import React, { ComponentPropsWithoutRef, FC } from 'react';
import { Row as CommonRow } from '../../landing.common';
import commonStyles from './common.module.scss';

export const Row: FC<ComponentPropsWithoutRef<'div'>> = ({ children, ...other }) => (
    <CommonRow className={commonStyles['row']} {...other}>
        {children}
    </CommonRow>
);
